const style = {
  container: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  groupName: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    cursor: 'pointer',
  },
  item: {
    flexBasis: '49%',
    paddingBottom: '8px',
  },
};

export default style;
